module.exports = {"330110001":"临平街道","330110002":"南苑街道","330110003":"东湖街道","330110004":"星桥街道","330110005":"五常街道","330110006":"乔司街道","330110007":"运河街道","330110008":"崇贤街道","330110009":"仁和街道","330110010":"良渚街道","330110011":"闲林街道","330110012":"仓前街道","330110013":"余杭街道","330110014":"中泰街道","330110102":"塘栖镇","330110109":"径山镇","330110110":"瓶窑镇","330110111":"鸬鸟镇","330110112":"百丈镇","330110113":"黄湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330110.json
// module id = 872
// module chunks = 0